module.exports = __webpack_public_path__ + "img/Poster2.c9404506.png";